import { connect } from 'react-redux';
import { fetchExportWageLedgerStatus } from 'src/reducers/reports/reportWageLedger';
import ExportButton from '../components/ExportButton';

function mapStateToProps(state) {
  return {
    jobStatus: state.JobStatus.exportWageLedgerJob
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchExportWageLedgerStatus: (interval, year, uniqueString) => {
      dispatch(fetchExportWageLedgerStatus(interval, year, uniqueString));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportButton);
